var map = {
	"./test-01.png": 90069,
	"./test-01_en.png": 64497,
	"./test-02.png": 28709,
	"./test-02_en.png": 33711,
	"./test-03.png": 23233,
	"./test-04.png": 37074,
	"./test-05.png": 27078,
	"./test-bg-01.png": 33336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97338;